import React, { useEffect, useRef, useState } from "react";
import {
  DataGrid,
  GridColDef,
  GridToolbar,
} from "@mui/x-data-grid";
import axios from "axios";
import HOST_URL from "../../utils/Url";
import Card from "@mui/material/Card";
import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  Stack,

  TextField,

  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../../utils/Url";
import IDCard from "./IDCard";
import { faL } from "@fortawesome/free-solid-svg-icons";
import loged from "../../assets/images/DrawerLogo.png";
import CSJMUlogo from "../../assets/images/CSJMUlogo.png";

import { useReactToPrint } from "react-to-print";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";



interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
}
interface ctgryOption {
  label: string;
  value: string;
}
export default function EmployeeIDCard() {
  const [students, setStudents] = useState([]);

  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();
  const [CategoryOption, setCategoryOption] = useState<ctgryOption[] | any>([]);
  const [Category_dept_Option, setCategory_dept_Option] = useState<ctgryOption[] | any>([]);
  const [studentsList, setStudentsList] = useState<ctgryOption[] | any>([]);
  const [CategoryValue, setCategoryValue] = useState("");
  const [CategoryDeptValue, setCategoryDeptValue] = useState("");
  const [yearValue, setYearValue] = React.useState<number>(0);
  const [deptValue, setDeptValue] = React.useState<any>("");
  const [categValue, setCategValue] = React.useState<any>("");
  const [yearOption, setYearOption] = React.useState<any>([]);
  const [deptOption, setDeptOption] = React.useState<any>([]);
  const [categOption, setCategOption] = React.useState<any>([]);


  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
  });
  const [applicableAcceOption, setASpplicableAcceOption] = useState<any>([{ value: "-1", label: ("Member Code") }]);
  console.log("🚀 ~ IssueReturn ~ applicableAcceOption:", applicableAcceOption)
  const [termData, setTermData] = useState("")
  const [timerCheck, setTimerCheck] = useState<NodeJS.Timeout | null>(null);
  const [applicableAcceOptionMemName, setApplicableAcceOptionMemName] = useState<any>("");
  const [memberCode, setmemberCode] = useState("");
  let navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const dataString = localStorage.getItem("userdata");
    if (dataString) {
      const data = JSON.parse(dataString);
      if (data && data.length > 0) {
        const userPermissionData = data[0]?.userPermission;
        if (userPermissionData && userPermissionData.length > 0) {
          const menudata = userPermissionData[0]?.parentMenu;
          for (let index = 0; index < menudata.length; index++) {
            const childMenudata = menudata[index]?.childMenu;
            const pathrow = childMenudata.find(
              (x: any) => x.path === location.pathname
            );
            console.log("data", pathrow);
            if (pathrow) {
              setPermissionData(pathrow);
              //fetchZonesData();

            }
          }
        }
      }
    }
    fetchctgry_Data();
    fetchfcltydept_Data();
    fetchCategory();
    //fetchStudent_Data();
  }, []);
  // }, [isLoading]);
  const routeChangeAdd = () => {
    let path = `/Employee/EmployeeAdd`;
    navigate(path);
  };

  const handleSwitchChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    value: any
  ) => {
    console.log(value)
    const updatedStatus = event.target.checked ? "Active" : "InActive";
    const collectData = {
      empid: value.id,
      empName: value.empName,
      empCode: value.empCode,
      userID: value.userID,
      sortOrder: value.sortOrder,
      empPerAddress: value.empPerAddress,
      empFatherName: value.empFatherName,
      empspauseName: value.empspauseName,
      empMotherName: value.empMotherName,
      empMobileNo: value.empMobileNo,
      empStatus: updatedStatus,
      empPanNumber: value.empPanNumber,
      empAddharNo: value.empAddharNo,
      empDob: value.empDob,
      empJoiningDate: value.JoinindDate,
      empretirementDate: value.empretirementDate,
      empPincode: value.empPincode,
      roleId: value.roleId,
      // imageFile: value.imageFile,
      // signatureFile: value.signatureFile,
      email: value.email,
      dlno: value.dlno,
      gender: value.gender,
      empLocalAddress: value.empLocalAddress,
      empDesignationId: value.empDesignationId,
      empDeptId: value.empDeptId,
      empStateId: value.StateId,
      empCountryID: value.empCountryID,
      empCityId: value.empCityId,
      user_ID: value.user_ID,
      // ...value,
      // empStatus: updatedStatus,
    };
    api
      .post(`EmpMaster/AddUpdateEmpmaster`, collectData)
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
          fetchZonesData();
        } else {
          toast.error(response.data.mesg);
        }
      });
  };
  const routeChangeEdit = (row: any) => {
    console.log("row " + row);

    let path = `/Employee/EmployeeEdit`;
    navigate(path, {
      state: row,
    });
  };



  let delete_id = "";

  const accept = () => {
    const collectData = {
      empid: delete_id,
    };

    api
      .delete(`EmpMaster/DeleteEmpmaster`, { data: collectData })
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        //fetchZonesData();
      });
  };

  const reject = () => {
    // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };

  const handledeleteClick = (del_id: any) => {
    // console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const fetchCategory = async () => {
    try {
      const response = await api.get("Member/GetDistinctMemberCategorydata");
      if (response.data.isSuccess) {
        setCategOption(response.data.data);
      }
    } catch (error) {
      console.log("Error fetching cayegory:", error);
    }
  }

  const fetchDepartmentWithCateg = async (code: any) => {
    if (code === null || code === "" || code === undefined) {
      setDeptOption([]);
      return;
    }
    try {
      const response = await api.get(`Member/GetDistinctMemberCategoryByDeaprtment?category=${code}`);
      if (response.data.isSuccess) {
        setDeptOption(response.data.data);
      }
    } catch (error) {
      console.log("Error fetching departments:", error);
    }
  }

  const fetchYears = async (code: any) => {
    try {
      const response = await api.get(`Member/GetDistinctMemberDeaprtmentByYear?department=${code}`);
      if (response.data.isSuccess) {
        setYearOption(response.data.data);
      }
    } catch (error) {
      console.log("Error fetching years:", error);
    }
  }

  const extract = (str: string) => (str.match(/\(([^)]+)\)/) || [])[1];


  const fetchctgry_Data = () => {
    const collectData = {
      ctgry_cd: "",

    };
    api
      .post(`Member/Getm_ctgry`, collectData)
      .then((response) => {
        const arr: ctgryOption[] = response.data.data.map((items: any) => ({
          label: items.ctgry_desc + " (" + items.ctgry_cd + ")",

          Value: items.ctgry_cd,
        }));
        setCategoryOption(arr);
      });
  };
  const fetchfcltydept_Data = () => {
    const collectData = {
      fld_tag: "",

    };
    api
      .post(`Member/Getm_fcltydept`, collectData)
      .then((response) => {
        const arr: ctgryOption[] = response.data.data.map((items: any) => ({
          label: items.fclty_dept_dscr + " (" + items.fclty_dept_cd + ")",

          Value: items.fclty_dept_cd,
        }));
        setCategory_dept_Option(arr);
      });
  };

  const fetchStudent_Data = () => {
    const collectData = {
      mem_cd: "",
      //mem_ctgry: CategoryValue,
      mem_ctgry: "",
      mem_inst: "",
      mem_dept: "",
      mem_degree: "",
      image: false,
      year: yearValue
    };
    api
      .post(`Member/Getm_member`, collectData)
      .then((response) => {
        const arr: ctgryOption[] = response.data.data.map((items: any) => ({
          label: [items.mem_firstnm, items.mem_midnm, items.mem_lstnm].filter(Boolean).join(" "),

          Value: items.mem_cd,
        }));
        setStudentsList(arr);
      });
  };


  const fetchZonesData = async () => {
    try {
      setIsLoading(true);
      const collectData = {
        mem_cd: memberCode,
        mem_ctgry: extract(categValue) || "",
        // mem_ctgry:  CategoryValue,
        // mem_ctgry:"CC",
        mem_inst: "",
        mem_dept: extract(deptValue) || "",
        // mem_dept: CategoryDeptValue,
        mem_degree: "",
        image: true,
        year: yearValue

      };
      console.log("collectData", collectData)
      const response = await api.post(
        `Member/Getm_member`,
        collectData
      );
      console.log("result", response.data.data)
      //const data = response.data.data;
      setIsLoading(false);

      if (response.data.isSuccess === false) {
        setStudents([]);
        return;
      }
      const arr = response.data.data.map((item: any) => ({
        name: [item.mem_firstnm, item.mem_midnm, item.mem_lstnm].filter(Boolean).join(" "),
        studentID: item.mem_cd,
        course: item.mem_degree,
        image: item.imageFile,
        college: "CHHATRAPATI SHAHU JI MAHARAJ UNIVERSITY,KANPUR",
        collegefoot: "FORMERLY KNOWN AS KANPUR UNIVERSITY",
        collegeLogo: CSJMUlogo,
        department: item.departmentName,
        mobile: item.mem_prmntphone,
        address: item.mem_prmntadd1,
        session: item.subject,
        dob: item.date_of_birth,
        efctv_dt: item.mem_efctv_dt,
        entry_dt: item.mem_entry_dt,
        effctupto: item.mem_effctupto,
        email: item.mem_email,
      }));

      setStudents(arr);
      setIsLoading(false);

    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));
  const handleInputChange = (event: any) => {

    const newQuery = event.target.value;
    console.log("newQuery", newQuery)
    if (newQuery != "") {
      setTermData(newQuery);
      console.log("newQuery 1  ", newQuery)
      if (timerCheck) {
        clearTimeout(timerCheck)
      }
      const checkResult = setTimeout(() => {
        getApplicableAccesion(newQuery);
      }, 500);
      setTimerCheck(checkResult)
    }
  }
  const getApplicableAccesion = async (nameData: any) => {

    // if (nameData.length < 3) {
    //   setTermData("");
    //   return;
    // }
    api
      .get(`AssigningRfid/GetMember?name=${nameData}`)
      .then((res) => {
        let arr: any = [];

        console.log("result" + JSON.stringify(res.data));


        const transformedData = transformData(res.data);
        setASpplicableAcceOption(transformedData);
        // for (let index = 0; index < res.data.length; index++) {
        //   arr.push({
        //     label: res.data[index]["label"],
        //     value: res.data[index]["value"]
        //   });
        // }
        // setASpplicableAcceOption(arr);
        // //setZoneOption(arr);
        // console.log(arr);
      });
  };
  const transformData = (data: any) => {
    return data.map((item: any) => {
      const name = item.label.replace(/^\(.*?\)/, '').trim();
      return {
        value: item.value,
        label: `${item.value} -- ${name} `,
        name: name
      };
    });
  };
  const printRef = useRef<HTMLDivElement>(null);
  //const printRef = useRef();
  const handlePrint = () => {
    const printContent = printRef?.current?.innerHTML;
    const originalContent = document.body.innerHTML;
    //document?.body?.innerHTML = printContent;
    if (document.body) {
      document.body.innerHTML = printContent || "";
    }
    window.print();
    document.body.innerHTML = originalContent;
    //window.location.reload();
  };

  const handleDownload = () => {
    const printContent = printRef.current?.innerHTML;
    if (printContent) {
      const doc = new jsPDF();
      html2canvas(printRef.current!, {
        logging: false,
        useCORS: true,
        scale: 2,
        backgroundColor: "#ffffff"
      }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = 190;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        doc.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
        doc.save("ID card.pdf");
      });
    }
  };


  return (
    <>
      <Card
        style={{
          width: "100%",
          backgroundColor: "#E9FDEE",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: "#2B4593",
              color: "#fff",
              fontSize: 17,
              fontWeight: 900,
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.EmpIDcard")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Stack direction="row" spacing={2} sx={{ mb: 2, flexWrap: 'wrap' }}>
            {/*permissionData?.isAdd == true && ( */}
            {/* <Button
              onClick={routeChangeAdd}
              variant="contained"
              endIcon={<AddCircleIcon />}
              size="large"
            >
              {t("text.Add")}
            </Button> */}
            {/*)} */}

            {/* {permissionData?.isPrint == true ? ( */}
            {/* <Button variant="contained" onClick={fetchZonesData} size="large">
                {t("text.print")}
              </Button> */}
            {/* ) : (
              ""
            )} */}
          </Stack>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={applicableAcceOption}
                getOptionLabel={(option: any) => `${option?.label}`}
                fullWidth
                size="small"
                value={applicableAcceOptionMemName?.value}
                onInputChange={(_, newInputValue) =>
                  handleInputChange({ target: { value: newInputValue } } as any)
                }
                onChange={(e: any, newValue: any) => {
                  console.log("🚀 ~ IssueReturn ~ newValue:", newValue);
                  if (newValue) {
                    setmemberCode(newValue.value);
                  } else {
                    setmemberCode("");
                  }
                  setApplicableAcceOptionMemName(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography>Select Member Code</Typography>
                    }
                  />
                )}
              />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={4} lg={4}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={CategoryOption}
                getOptionLabel={(option: any) => `${option?.label}`}
                fullWidth
                size="small"
                value={CategoryOption?.value}
                onChange={(e: any, newValue: any) => {
                  console.log("🚀 ~ IssueReturn ~ newValue:", newValue);
                  console.log("🚀 ~ IssueReturn ~ newValue:", newValue?.Value);
                  setCategoryValue(newValue?.Value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography>Select Category</Typography>
                    }
                  />
                )}
              />
            </Grid> */}


            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={categOption}
                fullWidth
                size="small"
                value={categValue}
                onChange={(e: any, newValue: any) => {
                  setCategValue(newValue);
                  fetchDepartmentWithCateg(extract(newValue) || "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography>Select Category</Typography>
                    }
                  />
                )}
              />
            </Grid>



            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={deptOption}
                fullWidth
                size="small"
                value={deptValue}
                onChange={(e: any, newValue: any) => {
                  setDeptValue(newValue)
                  fetchYears(extract(newValue) || "");
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography>Select Department</Typography>
                    }
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Autocomplete
                disablePortal
                id="year-dropdown"
                options={yearOption}
                getOptionLabel={(option: number) => option.toString()}
                fullWidth
                size="small"
                value={yearValue === 0 ? null : yearValue}
                onChange={(e: any, newValue: number | null) => {
                  setYearValue(newValue ? newValue : 0);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={<Typography>Select Year</Typography>}
                  />
                )}
              />
            </Grid>

            {/* <Grid item xs={12} sm={6} md={4} lg={4}>
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={Category_dept_Option}
                getOptionLabel={(option: any) => `${option?.label}`}
                fullWidth
                size="small"
                value={Category_dept_Option?.value}
                onChange={(e: any, newValue: any) => {
                  console.log("🚀 ~ IssueReturn ~ newValue:", newValue);
                  setCategoryDeptValue(newValue?.Value);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={
                      <Typography>Select Department</Typography>
                    }
                  />
                )}
              />
            </Grid> */}



            <Grid item xs={0} sm={6} md={8} lg={8}></Grid>

            {/* Buttons Section */}
            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Button
                variant="contained"
                size="small"
                fullWidth
                onClick={fetchZonesData}
              >
                {t("text.search")}
              </Button>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Button
                variant="contained"
                size="small"
                fullWidth
                onClick={() => handleDownload()}
              >
                {t("text.Download")}
              </Button>
            </Grid>

            <Grid item xs={12} sm={6} md={4} lg={4}>
              <Button
                variant="contained"
                size="small"
                fullWidth
                onClick={() => handlePrint()}
              >
                {t("text.print")}
              </Button>
            </Grid>
          </Grid>

          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Box>
              <br />
              <div
                id="receipt-content"
                ref={printRef}
                style={{
                  width: "100%",
                  backgroundColor: "#FFFFFF",
                }}
              >
                {/* <IDCard
                      name="Rahul Sharma"
                      studentID="STU123456"
                      course="Computer Science"
                      college="XYZ University"
                      image="https://via.placeholder.com/150"
                      collegeLogo="https://via.placeholder.com/80"
                  /> */}
                <IDCard students={students} />
              </div>
            </Box>
          )}
        </Paper>
      </Card>
      <ToastApp />
    </>

  );
}
